import React from 'react';
import './ErrorPopup.css';

const ErrorPopup = ({ error, onClose }) => {
  if (!error) return null;

  return (
    <div className="error-popup-overlay">
      <div className="error-popup">
        <div className="error-popup-header">
          <h2>Erro</h2>
          <button className="close-button" onClick={onClose}>
            ×
          </button>
        </div>
        <div className="error-popup-message">{error}</div>
      </div>
    </div>
  );
};

export default ErrorPopup;
